export default __webpack_public_path__ + "5419c543df27e6bc8ab782ee48a01030.svg";